import type { CSSProperties } from "react";

function MapArt({
  markerLabel,
  label,
  style,
  slice = false,
}: {
  markerLabel: string;
  label: string;
  style: CSSProperties;
  /** Fills the box it is drawn in, cut to fit, instead of keeping the whole drawing. */
  slice?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 1000 400"
      role="img"
      aria-label={label}
      preserveAspectRatio={slice ? "xMidYMid slice" : undefined}
      style={style}
    >
      <path d="M0 230 290 160 520 225 720 145 1000 225V400H0Z" fill="#d1decb" />
      <path d="M780 0 680 130 810 235 765 400H1000V0Z" fill="#c5e1e4" />
      <g stroke="#fff" strokeWidth="22" fill="none">
        <path d="M0 110H710M90 0 290 400M390 0 480 400M610 0 550 400M0 300 770 180M0 350 770 330" />
      </g>
      <g fill="#ccc9bd">
        <path d="m140 140 210-5 12 84-181 30Z" />
        <path d="m410 35 153 0-20 71-124 0Z" />
        <path d="m298 302 153-43 9 65-124 2Z" />
      </g>
      <g transform="translate(500 175)">
        <path
          d="M0 45C-12 26-35 4-35-17a35 35 0 1 1 70 0C35 4 12 26 0 45Z"
          fill="var(--map-pin-color, #355238)"
          stroke="white"
          strokeWidth="4"
        />
        <circle cy="-17" r="11" fill="white" />
      </g>
      <rect x="366" y="240" width="270" height="50" rx="8" fill="white" />
      <text
        x="501"
        y="272"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize="21"
        fill="#334138"
      >
        {markerLabel}
      </text>
    </svg>
  );
}

/** The guide does not contact the customer's external map service. */
export default function MapIllustration({
  markerLabel = "Din forretning",
  caption,
}: { markerLabel?: string; caption?: string } = {}) {
  return (
    <figure style={{ margin: 0, padding: "24px", color: "#334138" }}>
      <MapArt
        markerLabel={markerLabel}
        label="Illustration af et kort med forretningens placering"
        style={{
          width: "100%",
          maxHeight: "440px",
          background: "#e9e7df",
          borderRadius: "12px",
        }}
      />
      <figcaption style={{ fontSize: "14px", marginTop: "12px" }}>
        {caption ||
          "Kortillustration. På hjemmesiden viser MapComponent et interaktivt kort med forretningens adresse fra korttjenesten."}
      </figcaption>
    </figure>
  );
}

/**
 * Sagskort's map box in the CMS's preview: the map as large as the box, cut to fit, without a caption. Out of flow, as
 * the map's own canvas is, so the drawing's shape does not set the box's height.
 */
export function CaseMapIllustration({ markerLabel }: { markerLabel: string }) {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <MapArt
        markerLabel={markerLabel}
        label="Illustration af et kort med boligens placering"
        slice
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          background: "#e9e7df",
        }}
      />
    </div>
  );
}
